// extracted by mini-css-extract-plugin
export default {"qrCode":"QrCodes_qrCode__1a0MJ","borderQr":"QrCodes_borderQr__STKAZ"};